import { arrayDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default arrayDuckCreator({
    ...srpDuckPreset,
    store: 'editorialReviews',
});
